import { NgModule }            from '@angular/core';
import { FactoryTypesService } from './factory-types.service';

@NgModule({
  providers: [FactoryTypesService]
})
export class FactoryTypeModule { }
